import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';
import { mapSubscriptionBlockToViewDto } from '@subscriptions/application/mappers';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for listing all subscription blocks of an organization.
 *
 * @param port - Subscription block API port
 * @returns Use case executor
 */
export const listSubscriptionBlocksUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (): Promise<SubscriptionBlockViewDto[]> => {
    try {
      const blocks = await port.list();
      return blocks.map(mapSubscriptionBlockToViewDto);
    } catch (error) {
      subLog.error('listSubscriptionBlocks', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
